// src/pages/Connections/index.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
// primereact
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { BreadCrumb } from "primereact/breadcrumb";
import { confirmDialog } from "primereact/confirmdialog";
// components
import Panel from "../../components/panel/panel";
import ModalFacebook from "./Facebook/ModalFacebook";
import ModalConnections from "./ModalConnections";
import ModalWhatsAppConnection from "./WhatsApp/ModalWhatsAppConnection";
import ModalLinkEnterprises from "./WhatsApp/ModalLinkEnterprises";
// services
import { getWhatsappConnections } from "../../services/WhatsappConnection/getWhatsappConnections";
import { deleteWhatsappConnection } from "../../services/WhatsappConnection/deleteWhatsappConnection";
import { postWhatsappDisconnect } from "../../services/WhatsappConnection/postWhatsappDisconnect";
import { postWhatsappConnect } from "../../services/WhatsappConnection/postWhatsappConnect";

const Connections = () => {
  const [visibleFacebook, setVisibleFacebook] = useState(false);
  const [visibleConnections, setVisibleConnections] = useState(false);
  const [visibleWhatsAppConnection, setVisibleWhatsAppConnection] =
    useState(false);
  const [visibleLinkEnterprises, setVisibleLinkEnterprises] = useState(false);
  const [selectedConnectionId, setSelectedConnectionId] = useState(null);
  const [selectedConnectionForLink, setSelectedConnectionForLink] = useState(null);
  const [deletingConnectionId, setDeletingConnectionId] = useState(null);
  const [disconnectingConnectionId, setDisconnectingConnectionId] = useState(null);
  const [connectingConnectionId, setConnectingConnectionId] = useState(null);

  const {
    data: connectionsData,
    isLoading: isLoadingConnections,
    isError,
    refetch,
  } = useQuery(["whatsapp-connections"], getWhatsappConnections, {
    staleTime: 1000 * 10, // 10 segundos
    retry: 2,
    onError: (error) => {
      console.error("Erro ao carregar conexões:", error);
    },
  });

  const connections = connectionsData?.data || [];

  const columns = [
    { field: "id", header: "ID" },
    {
      field: "is_connected",
      header: "Status",
      body: (row) => (
        <span
          className={`badge ${row.is_connected ? "bg-success" : "bg-danger"}`}
        >
          {row.is_connected ? "Conectado" : "Desconectado"}
        </span>
      ),
    },
    {
      field: "connection_exhausted",
      header: "Esgotado",
      body: (row) => (
        <span
          className={`badge ${
            !row.connection_exhausted ? "bg-success" : "bg-warning"
          }`}
        >
          {!row.connection_exhausted ? "Não" : "Sim"}
        </span>
      ),
    },
    {
      field: "created_at",
      header: "Criado em",
      body: (row) => new Date(row.created_at).toLocaleDateString("pt-BR"),
    },
    {
      field: "updated_at",
      header: "Atualizado em",
      body: (row) => new Date(row.updated_at).toLocaleDateString("pt-BR"),
    },
  ];

  const items = [
    {
      template: () => (
        <Link to="/settings/connections" className="p-breadcrumb-link">
          Conexões meta
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to="#" className="p-breadcrumb-link">
        <i className="fa fa-home" />
      </Link>
    ),
  };

  useEffect(() => {
    const { access_token, state } = Object.fromEntries(
      new URLSearchParams(window.location.hash.slice(1))
    );
    if (access_token && state === "facebook_login") {
      setVisibleFacebook(true);
    }
  }, []);

  const getConnectTooltip = (row) => {
    if (row.qrcode) {
      return "Conectar WhatsApp - QR Code disponível";
    }
    
    const createdAt = new Date(row.created_at);
    const now = new Date();
    const diffMinutes = (now - createdAt) / (1000 * 60);
    
    if (diffMinutes >= 3) {
      return "Conectar";
    } else {
      const remainingMinutes = Math.ceil(3 - diffMinutes);
      return `Aguarde ${remainingMinutes} minuto(s) ou até o QR Code aparecer`;
    }
  };
  
  const handleDelete = (row) => {
    const connectionStatus = row.is_connected ? "conectada" : "desconectada";
    const warningMessage = row.is_connected 
      ? " A conexão está ativa e será perdida permanentemente."
      : "";
    
    confirmDialog({
      message: `Tem certeza que deseja excluir a conexão WhatsApp #${row.id}?${warningMessage} Esta ação não pode ser desfeita.`,
      header: "Confirmar Exclusão",
      icon: "fa-solid fa-triangle-exclamation",
      acceptLabel: "Sim",
      rejectLabel: "Cancelar",
      acceptClassName: "p-button-danger ms-2",
      rejectClassName: "p-button-outlined me-2",
      accept: () => {
        deleteConnection(row.id);
      },
      reject: () => {
        toast.info("Exclusão cancelada.");
      }
    });
  };

  const deleteConnection = async (connectionId) => {
    setDeletingConnectionId(connectionId);
    const toastId = toast.loading("Excluindo conexão...");
    
    try {
      await deleteWhatsappConnection(connectionId);
      
      toast.update(toastId, {
        render: "Conexão excluída com sucesso!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      
      refetch();
    } catch (error) {
      console.error("Erro ao excluir conexão:", error);
      toast.update(toastId, {
        render: "Erro ao excluir conexão. Tente novamente.",
        type: "error",
        isLoading: false,
        autoClose: 4000,
      });
    } finally {
      setDeletingConnectionId(null);
    }
  };

  const handleDisconnect = (row) => {
    confirmDialog({
      message: `Tem certeza que deseja desconectar a sessão WhatsApp #${row.id}? A conexão será perdida e será necessário escanear o QR Code novamente para reconectar.`,
      header: "Confirmar Desconexão",
      icon: "fa-solid fa-plug-circle-xmark",
      acceptLabel: "Sim, Desconectar",
      rejectLabel: "Cancelar",
      acceptClassName: "p-button-warning ms-2",
      rejectClassName: "p-button-outlined me-2",
      accept: () => {
        disconnectConnection(row.id);
      },
      reject: () => {
        toast.info("Desconexão cancelada.");
      }
    });
  };

  const disconnectConnection = async (connectionId) => {
    setDisconnectingConnectionId(connectionId);
    const toastId = toast.loading("Desconectando sessão...");
    
    try {
      await postWhatsappDisconnect(connectionId);
      
      toast.update(toastId, {
        render: "Sessão desconectada com sucesso!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      
      refetch();
    } catch (error) {
      console.error("Erro ao desconectar sessão:", error);
      toast.update(toastId, {
        render: "Erro ao desconectar sessão. Tente novamente.",
        type: "error",
        isLoading: false,
        autoClose: 4000,
      });
    } finally {
      setDisconnectingConnectionId(null);
    }
  };

  const handleConnect = (row) => {
    if (!row.is_connected && !row.connection_exhausted) {
      if (!row.qrcode) {
        const createdAt = new Date(row.created_at);
        const now = new Date();
        const diffMinutes = (now - createdAt) / (1000 * 60); 
        
        if (diffMinutes >= 3) {
          handleReconnect(row);
        } else {
          const remainingMinutes = Math.ceil(3 - diffMinutes);
          toast.info(`Aguarde ${remainingMinutes} minuto(s) ou até o QR Code aparecer antes de tentar reconectar.`);
          
          setSelectedConnectionId(row.id);
          setVisibleWhatsAppConnection(true);
        }
      } else {
        setSelectedConnectionId(row.id);
        setVisibleWhatsAppConnection(true);
      }
    } else {
      setSelectedConnectionId(row.id);
      setVisibleWhatsAppConnection(true);
    }
  };

  const handleReconnect = async (row) => {
    setConnectingConnectionId(row.id);
    const toastId = toast.loading("Preparando conexão...");
    
    try {
      await postWhatsappConnect(row.id);
      
      toast.update(toastId, {
        render: "Conexão preparada! Escaneie o QR Code.",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      });
      
      await refetch();
      setSelectedConnectionId(row.id);
      setVisibleWhatsAppConnection(true);
      
    } catch (error) {
      console.error("Erro ao preparar conexão:", error);
      toast.update(toastId, {
        render: "Erro ao preparar conexão. Tente novamente.",
        type: "error",
        isLoading: false,
        autoClose: 4000,
      });
    } finally {
      setConnectingConnectionId(null);
    }
  };

  const handleConnectionCreatedWithId = (connectionId) => {
    setSelectedConnectionId(connectionId);
    setVisibleWhatsAppConnection(true);
  };

  const handleLinkEnterprises = (row) => {
    setSelectedConnectionForLink(row);
    setVisibleLinkEnterprises(true);
  };

  return (
    <>
      <div className="row justify-content-between align-items-center mb-2">
        <div className="col-md-6">
          <BreadCrumb
            model={items}
            home={home}
            style={{
              background: "transparent",
              border: "none",
              fontSize: "16px",
            }}
          />
        </div>
        <div className="col-md-6 d-flex justify-content-end gap-2">
          <Button
            rounded
            label="Nova Conexão"
            icon="fa-solid fa-plus"
            onClick={() => setVisibleConnections(true)}
          />
        </div>
      </div>

      {isLoadingConnections ? (
        <Skeleton className="mt-4" width="100%" height={400} />
      ) : isError ? (
        <Panel mainCss="mt-4" title="Conexões WhatsApp">
          <div className="alert alert-danger" role="alert">
            Erro ao carregar as conexões do WhatsApp.
            <button className="btn btn-link p-0 ms-2" onClick={() => refetch()}>
              Tentar novamente
            </button>
          </div>
        </Panel>
      ) : (
        <Panel mainCss="mt-4" title="Conexões WhatsApp">
          <DataTable
            value={connections}
            paginator
            rows={10}
            rowsPerPageOptions={[10, 25, 50]}
            emptyMessage="Nenhuma conexão encontrada."
          >
            {columns.map((col) => (
              <Column
                key={col.field}
                field={col.field}
                header={col.header}
                body={col.body}
              />
            ))}
            <Column
              header="Ações"
              body={(row) => (
                <div className="d-flex gap-2">
                  {row.is_connected && (
                    <Button
                      icon="fa-solid fa-link"
                      tooltip="Vincular Empreendimentos"
                      tooltipOptions={{ position: "top" }}
                      onClick={() => handleLinkEnterprises(row)}
                      size="small"
                      severity="success"
                      outlined
                    />
                  )}
                  {!row.is_connected && !row.connection_exhausted && (
                    <Button
                      icon={connectingConnectionId === row.id ? "fa-solid fa-spinner fa-spin" : "fa-solid fa-plug"}
                      tooltip={connectingConnectionId === row.id ? "Preparando conexão..." : getConnectTooltip(row)}
                      tooltipOptions={{ position: "top" }}
                      onClick={() => handleConnect(row)}
                      size="small"
                      severity="success"
                      disabled={connectingConnectionId === row.id}
                      loading={connectingConnectionId === row.id}
                    />
                  )}
                  {row.is_connected && (
                    <Button
                      icon={disconnectingConnectionId === row.id ? "fa-solid fa-spinner fa-spin" : "fa-solid fa-plug-circle-xmark"}
                      tooltip={disconnectingConnectionId === row.id ? "Desconectando..." : "Desconectar WhatsApp"}
                      tooltipOptions={{ position: "top" }}
                      onClick={() => handleDisconnect(row)}
                      size="small"
                      severity="warning"
                      disabled={disconnectingConnectionId === row.id}
                      loading={disconnectingConnectionId === row.id}
                    />
                  )}
                  {row.connection_exhausted && !row.is_connected && (
                    <Button
                      icon="fa-solid fa-exclamation-triangle"
                      tooltip="Conexão esgotada"
                      tooltipOptions={{ position: "top" }}
                      size="small"
                      severity="secondary"
                      disabled
                    />
                  )}
                  {/* <Button
                    icon="fa-solid fa-pen-to-square"
                    tooltip="Editar"
                    tooltipOptions={{ position: "top" }}
                    onClick={() => handleEdit(row)}
                    size="small"
                  /> */}
                  <Button
                    icon={deletingConnectionId === row.id ? "fa-solid fa-spinner fa-spin" : "fa-solid fa-trash-can"}
                    tooltip={deletingConnectionId === row.id ? "Excluindo..." : "Excluir"}
                    tooltipOptions={{ position: "top" }}
                    severity="danger"
                    onClick={() => handleDelete(row)}
                    size="small"
                    disabled={deletingConnectionId === row.id}
                    loading={deletingConnectionId === row.id}
                  />
                </div>
              )}
            />
          </DataTable>
        </Panel>
      )}

      <ModalConnections
        visible={visibleConnections}
        onHide={() => setVisibleConnections(false)}
        setVisibleFacebook={setVisibleFacebook}
        onConnectionCreated={() => refetch()}
        onConnectionCreatedWithId={handleConnectionCreatedWithId}
      />

      <ModalFacebook
        visible={visibleFacebook}
        onHide={() => setVisibleFacebook(false)}
      />

      <ModalWhatsAppConnection
        visible={visibleWhatsAppConnection}
        onHide={() => setVisibleWhatsAppConnection(false)}
        connectionId={selectedConnectionId}
        onConnectionSuccess={() => refetch()}
      />

      <ModalLinkEnterprises
        visible={visibleLinkEnterprises}
        onHide={() => setVisibleLinkEnterprises(false)}
        connectionId={selectedConnectionForLink?.id}
        connectionName={`Conexão #${selectedConnectionForLink?.id}`}
      />
    </>
  );
};

export default Connections;
